module.exports = __webpack_public_path__ + "img/error.4b3ea880.svg";